import * as React from "react";
import { useEffect, useState, useRef } from "react";

const loadScript = (docum, scriptTagName, id, scriptSrc, callback, onError) => {
  const element = docum.getElementsByTagName(scriptTagName)[0];
  const someOtherScript = element;
  // let js; // = element;
  const script = docum.createElement(scriptTagName);
  script.id = id;
  script.src = scriptSrc;
  script.async = true;
  if (someOtherScript && someOtherScript.parentNode) {
    someOtherScript.parentNode.insertBefore(script, someOtherScript);
  } else {
    docum.head.appendChild(script);
  }
  script.onError = onError;
  script.onload = callback;
};

const removeScript = (docum, id) => {
  const element = docum.getElementById(id);

  if (element) {
    element.parentNode?.removeChild(element);
  }
};

export const GoogleSigninButton = ({ callback, clientId, width }) => {
  const buttonWidth = width ? width + "px" : "";
  const googleButtonOpt = {
    theme: "outline",
    // size: "medium",
    type: "standard",
    text: "continue_with",
    shape: "rectangular",
    logo_alignment: "center",
    width: buttonWidth,
  };

  const divRef = useRef(null);
  //const [scriptLoaded, setScriptLoaded] = useState(false);

  useEffect(() => {
    loadScript(
      document,
      "script",
      "google-login",
      "https://accounts.google.com/gsi/client",
      () => {
        //setScriptLoaded(true);
        google.accounts.id.initialize({
          client_id: clientId,
          callback: callback,
        });
        google.accounts.id.renderButton(divRef.current, googleButtonOpt);
        // google.accounts.id.prompt(); // also display the One Tap dialog
      }
    );
    return function cleanup() {
      removeScript(document, "google-login");
    };
  }, []);

  //if (!scriptLoaded) return null; // Do not render before the google library is loaded

  return <div className="login-container-google-signin" ref={divRef} />;
};
